import { Constants } from "@core/Utils/Constants";
import { ButtonState } from "../Button";
import { MenuButton } from "./MenuButton";

export class MenuSettings extends MenuButton {

    protected buttonHeightMultiplier: number; //how many times is this taller than a normal menu button ?

    constructor(scene: Phaser.Scene, text: string, spriteSheet: string, icon: string, buttonHeightMultiplier: number) {
        super(scene, text, spriteSheet, icon);
        this.buttonHeightMultiplier = buttonHeightMultiplier;
    }

    override ResizeAndMove(x: number, y: number, width: number, singleButtonHeight: number, padding: number) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = singleButtonHeight * this.buttonHeightMultiplier;

        this.padding = padding;

        this.background.clear();
        this.background.fillGradientStyle(0x000000, 0x000000, 0x000000, 0x000000, 0.3, 0.3, 0, 0);
        this.background.fillRect(0, 0, width, this.height);
        this.background.input.hitArea.setSize(width, this.height);

        this.background.lineStyle(1, 0xffffff, 0.5);
        this.background.lineBetween(0, 0, width, 0);

        if (this.state == ButtonState.Disabled) {
            this.buttonText.setStyle(Constants.MENU_BUTTON_STYLE_FONT_DISABLED);
            this.buttonIcon.setTint(0x8a8a8a);
        }
        else {
            this.buttonText.setStyle(Constants.MENU_BUTTON_STYLE_FONT);
            this.buttonIcon.clearTint();
        }

        this.buttonText.setFontSize(singleButtonHeight / 3);
        this.buttonText.setPosition(this.padding * 2, this.padding * 3);

        this.buttonIcon.setDisplaySize(singleButtonHeight / 2.5, singleButtonHeight / 2.5);
        this.buttonIcon.setPosition((width - this.buttonIcon.displayWidth / 2) - (this.padding * 2), singleButtonHeight / 3);
    }

    override handleUp(m, x, y, e): void {
        e.stopPropagation();
    }

    override handleOut(m, x, y, e): void {
    }

    override handleDown(m, x, y, e): void {
        e.stopPropagation();
    }

    override handleOver(m, x, y, e): void {
    }
}